import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/technology-unified-architecture.svg")